module.exports = __webpack_public_path__ + "img/gift.8af113d8.svg";